<template>
    <app-layout>
        <common-content-spacer height="medium">
            <common-breadcrumbs :breadcrumbs="pageBreadcrumbs"></common-breadcrumbs>
            <common-page-header :heading="pageTitle"></common-page-header>
            <common-page-plain>
                <patient-members-list></patient-members-list>
            </common-page-plain>
        </common-content-spacer>
    </app-layout>
</template>
<script>
    import AppLayout from 'components/layouts/AppLayout'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import PatientMembersList from 'components/page-elements/patient/PatientMembersList'

    export default {
        mixins: [PageWithDataMixin],
        components: {
            AppLayout,
            PatientMembersList,
        },

        computed: {
            pageTitle() {
                return this.$t('pages.patient.details.titles.upload_title', { patientListTitle: 'patients' })
            },

            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.patient.details.breadcrumbs.patient'),
                        route: { name: 'practice.profile' },
                    },
                    {
                        label: this.$t('pages.patient.details.breadcrumbs.patient_list'),
                    },
                ]
            },
        },
    }
</script>
